var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16C3.89733 16 3 15.1027 3 14C3 12.8973 3.89733 12 5 12C6.10267 12 7 12.8973 7 14C7 15.1027 6.10267 16 5 16ZM5 13.3333C4.63333 13.3333 4.33333 13.632 4.33333 14C4.33333 14.368 4.63333 14.6667 5 14.6667C5.36667 14.6667 5.66667 14.368 5.66667 14C5.66667 13.632 5.36667 13.3333 5 13.3333Z",
    fill: "#67E2C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_45_284)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 14.5,
    fill: "url(#paint0_linear_45_284)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2321 23.4379L20.5396 23.4379C19.2028 23.438 18.1155 24.5253 18.1155 25.862L18.1155 32.0954C18.1155 33.4321 19.2028 34.5194 20.5396 34.5194L21.2321 34.5194C22.5689 34.5194 23.6562 33.4321 23.6562 32.0954L23.6562 25.862C23.6562 24.5253 22.5689 23.4379 21.2321 23.4379ZM20.5396 32.4417C20.3484 32.4417 20.1933 32.2865 20.1933 32.0954L20.1933 25.862C20.1933 25.6709 20.3484 25.5157 20.5396 25.5157L21.2321 25.5157C21.4233 25.5157 21.5784 25.6709 21.5784 25.862L21.5784 32.0954C21.5784 32.2837 21.4205 32.4417 21.2321 32.4417L20.5396 32.4417Z",
    fill: "#108DA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6205 17.9249C25.4487 17.9249 24.2671 18.9527 24.2671 21.2494C24.2671 22.2938 23.1091 23.3895 22.0259 24.0668L23.1271 25.8288C24.094 25.2235 26.3449 23.5682 26.3449 21.2494C26.3449 20.3504 26.597 20.0304 26.6621 19.9944C26.7133 20.0622 27.2023 20.644 27.2023 21.8865C27.2023 23.1374 26.7258 23.9006 26.7203 23.9089C26.518 24.2275 26.5014 24.6389 26.6843 24.9713C26.8657 25.3038 27.212 25.5157 27.5902 25.5157L31.0531 25.5157C31.9397 25.5157 32.6599 26.236 32.6599 27.1225C32.6295 27.4952 32.0241 30.5523 31.9244 30.9817C31.9133 31.0191 31.905 31.0579 31.8981 31.0966C31.7748 31.8502 31.0448 32.4417 30.2359 32.4417L29.5294 32.4417C26.0623 32.4417 24.1424 31.5593 23.4789 31.1784L22.4484 32.9833C23.4526 33.5567 25.7063 34.5194 29.5294 34.5194L30.2359 34.5194C32.0643 34.5194 33.6614 33.1924 33.9496 31.4319L33.9343 31.4291C34.0479 31.0177 34.1643 30.4151 34.336 29.5314C34.7377 27.4647 34.7377 27.25 34.7377 27.1225C34.7377 25.0919 33.0852 23.4379 31.0531 23.4379L29.1028 23.4379C29.2067 22.9988 29.2801 22.478 29.2801 21.8865C29.2801 19.4071 27.9268 17.9249 26.6205 17.9249Z",
    fill: "#108DA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 47C15.3979 47 15.2645 46.9739 15.1366 46.9216C14.7516 46.7621 14.5 46.3854 14.5 45.9688V40.125H12.7812C10.6954 40.125 9 38.4296 9 36.3438V17.7812C9 15.6954 10.6954 14 12.7812 14H38.2188C40.3046 14 42 15.6954 42 17.7812V36.3438C42 38.4296 40.3046 40.125 38.2188 40.125H22.8339L16.2614 46.6975C16.0634 46.8955 15.7994 47 15.5312 47ZM12.7812 16.0625C11.8339 16.0625 11.0625 16.8339 11.0625 17.7812V36.3438C11.0625 37.2911 11.8339 38.0625 12.7812 38.0625H15.5312C16.1005 38.0625 16.5625 38.5245 16.5625 39.0938V43.4786L21.6775 38.3636C21.8714 38.1698 22.1326 38.0611 22.4062 38.0611H38.2188C39.1661 38.0611 39.9375 37.2898 39.9375 36.3424V17.7812C39.9375 16.8339 39.1661 16.0625 38.2188 16.0625H12.7812Z",
    fill: "#108DA0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_45_284",
    x: 2,
    y: 1,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_45_284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_284",
    x1: 26.5,
    y1: 11,
    x2: 26.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4FF99",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social_media.65985dfc2ef8fd16f6f6f4d37a7bea13.svg";
export { ForwardRef as ReactComponent };